export const canTrack = () => {
  let canTrack = true
  const dntStatus = navigator.doNotTrack || window.doNotTrack || navigator.msDoNotTrack
  if (dntStatus === '1') {
    canTrack = false
  } else if (dntStatus === '0') {
    canTrack = true
  }
  return canTrack
}
